import React, { useEffect } from 'react';
import { Modal, useAppDispatch, useAppState } from '@nutastic/nutastic-react-app';
import { WebsiteActions } from '../state/actions.mjs';
import togglePageLock from '../utils/togglePageLock';

const componentClass = 'appMessageModal';

const MessageModal = () => {
    const appDispatch = useAppDispatch();
    const {
        appMessage: { title, text } = {}
    } = useAppState();
    const isActive = !!text;

    useEffect(() => {
        if (isActive) {
            togglePageLock(true);
        } else {
            togglePageLock(false);
        }

        return () => {
            togglePageLock(false);
        }
    }, [isActive]);

    const onAccountModalClose = () => {
        togglePageLock(false);
        appDispatch({ type: WebsiteActions.APP_MESSAGE_CHANGE, title: null, text: null });
    };

    return <Modal className={componentClass} show={isActive} onClose={onAccountModalClose} nodeId="root" title={title} closeOnOuterClick={false}>
        <p>{ text }</p>
    </Modal>;
};

export default MessageModal;
